import axios from "axios";

const axiosInstance = axios.create({
 baseURL: process.env.REACT_APP_API_BASE_URL
});

axiosInstance.defaults.withCredentials = true;

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      console.error("Network Error:", error);
      return Promise.reject("Network error! Please check your internet connection.");
    }

    const { status } = error.response;
    const publicRoutes = [
      "/sign-in",
      "/sign-up",
      "/forgot-password",
      "/verify-email",
      "/resend-email",
      "/reset-password",
      "/verify"
    ];

    const isPublicRoute = publicRoutes.some((route) =>
      window.location.pathname.startsWith(route)
    );

    // 403 Forbidden -> Redirect to home
    if (status === 403) {
      alert("403 Forbidden: Access denied.");
      window.location.replace("/");
    }

    // 401 Unauthorized -> Redirect ONLY if NOT on a public route
    if (status === 401 && !isPublicRoute) {
      window.location.replace("/sign-in");
    }

    return Promise.reject(error.response || "Something went wrong!");
  }
);

export default axiosInstance;
